import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Fonts, Palette } from '../../components/utils';
import { getInitialsFromName, resolveChatAvatarUrl } from './chatAvatarUtils';

const ChatAvatar = ({ avatar, name = '', size = 48, fontSize = 16, hoverName }) => {
  const url = resolveChatAvatarUrl(avatar);
  const initials = getInitialsFromName(name);
  const [failed, setFailed] = useState(false);
  // Name tooltip is opt-in (thread avatars). List rows pass name for initials only.
  const tooltip = hoverName || undefined;

  useEffect(() => {
    setFailed(false);
  }, [url]);

  if (!url || failed) {
    return (
      <AvatarInitials
        $size={size}
        $fontSize={fontSize}
        title={tooltip}
        aria-label={tooltip}
      >
        {initials}
      </AvatarInitials>
    );
  }

  return (
    <AvatarImg
      key={url}
      src={url}
      alt={tooltip || ''}
      title={tooltip}
      $size={size}
      onError={() => setFailed(true)}
    />
  );
};

const AvatarImg = styled.img`
  display: block;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
  background: ${Palette.HAZY_BLUE};
`;

const AvatarInitials = styled.div`
  box-sizing: border-box;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${Palette.HAZY_BLUE};
  color: ${Palette.WHITE};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: ${({ $fontSize }) => $fontSize}px;
  font-weight: 600;
  font-style: normal;
  line-height: 100%;
  letter-spacing: 0;
`;

export default ChatAvatar;
